import { render, staticRenderFns } from "./WorkActionsDialog.vue?vue&type=template&id=93624c08&"
import script from "./WorkActionsDialog.vue?vue&type=script&lang=js&"
export * from "./WorkActionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports